import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Table from "react-bootstrap/Table";
import Badge from "react-bootstrap/Badge";
import SearchRequest from "../../magData/Train/SearchRequest";
import SearchResponse from "../../magData/Train/SearchResponse";

function TrainSearchPage(props) {
  return (
    <>
      <Container fluid>
        <Row>
          <Col sm={12}>
            <p className="page-title">Train Search Method</p>
          </Col>
          <Col sm={12}>
            <p>EndPoint : https://gdscpapi.parsgds.com/gateway/Train/search</p>
          </Col>
          <Col sm={12}>
            <p> type : json (default)</p>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <p>Body Parameters</p>
          </Col>
          <Col sm={12}>
            <Table striped bordered>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Additional information</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>AdultCount</td>
                  <td>
                    <p>Number of Adults</p>
                  </td>
                  <td>
                    integer
                  </td>
                  <td>
                    <p>Required</p>
                  </td>
                </tr>
                <tr>
                  <td>ChildCount</td>
                  <td>
                    <p>Number of Childs</p>
                  </td>
                  <td>
                    integer
                  </td>
                  <td>
                    <p>Required</p>
                  </td>
                </tr>
                <tr>
                  <td>InfantCount</td>
                  <td>
                    <p>Number of Infants</p>
                  </td>
                  <td>
                    integer
                  </td>
                  <td>
                    <p>Required</p>
                  </td>
                </tr>
                <tr>
                  <td>RailTripType</td>
                  <td>
                    <p>Trip Type</p>
                  </td>
                  <td>
                    <p>RailTripType</p>
                  </td>
                  <td>
                    <p>Required</p>
                  </td>
                </tr>
                <tr>
                  <td colSpan={4}>
                    <Table striped bordered>
                        <tbody>
                          <tr>
                            <td><>OneWay</></td>
                            <td>
                              <p>1</p>
                            </td>
                            <td>
                              <p>One Way</p>
                            </td>
                          </tr>
                          <tr>
                            <td><p>Return</p></td>
                            <td>
                              <p>2</p>
                            </td>
                            <td>
                              <p>Round Trip</p>
                            </td>
                          </tr>
                      </tbody>
                    </Table>
                  </td>
                  </tr>
                <tr>
                  <td>OriginDestinationInformations</td>
                  <td>
                    <p>Origin and Destination details</p>
                  </td>
                  <td>
                    <p>Collection of RailOriginDestinationInformation</p>
                  </td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td colSpan={4}>
                    <Table bordered>
                      <tbody>
                          <tr>
                            <td>DepartureDateTime</td>
                            <td>
                              <p>Departure Date and Time</p>
                            </td>
                            <td>
                              date
                            </td>
                            <td>
                              <p>Required</p>
                            </td>
                          </tr>
                          <tr>
                            <td>DestinationLocationCode</td>
                            <td>
                              <p>Destination Airport/Rail Station/City Code</p>
                            </td>
                            <td>
                              string
                            </td>
                            <td>
                              <p>Required</p>
                            </td>
                          </tr>
                          <tr>
                            <td>OriginLocationCode</td>
                            <td>
                              <p>Origin Airport/Rail Station/Local Code</p>
                            </td>
                            <td>
                              string
                            </td>
                            <td>
                              <p>Required</p>
                            </td>
                          </tr>
                      </tbody>
                    </Table>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <span className="code-section-title">
              Request Formats - application/json, text/json
            </span>
          </Col>
          <Col sm={12}>
            <pre className="code-section">
              {JSON.stringify(SearchRequest, null, 2)}
            </pre>
          </Col>
        </Row>

        {/* Response  */}
        <Row>
          <Col sm={12}>
            <p>Response Information</p>
          </Col>
          <Col sm={12}>
            <Table striped bordered>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Additional information</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>DestinationLocationCode</td>
                  <td>
                    <p>Destination Airport/Rail Station/City Code</p>
                  </td>
                  <td>
                    string
                  </td>
                  <td>
                    <p>Required</p>
                  </td>
                </tr>
                <tr>
                  <td>OriginLocationCode</td>
                  <td>
                    <p>Origin Airport/Rail Station/Local Code</p>
                  </td>
                  <td>
                    string
                  </td>
                  <td>
                    <p>Required</p>
                  </td>
                </tr>
                <tr>
                  <td>PricedItineraries</td>
                  <td>
                    <p>Flight Itinerary</p>
                  </td>
                  <td>
                    Object
                  </td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                <td colSpan={4}>
                  <Table bordered>
                        <tbody>
                          <tr>
                            <td>IsPassportMandatory</td>
                            <td>
                              <p>Mandatory information</p>
                            </td>
                            <td>
                              boolean
                            </td>
                            <td>
                              <p>None.</p>
                            </td>
                          </tr>
                          <tr>
                            <td>RailTripType</td>
                            <td>
                              <p>Trip Type</p>
                            </td>
                            <td>
                              <p>RailTripType</p>
                            </td>
                            <td>
                              <p>None.</p>
                            </td>
                          </tr>
                          <tr>
                            <td>Validating</td>
                            <td>
                              <p>Validating Carrier Code</p>
                            </td>
                            <td>
                              string
                            </td>
                            <td>
                              <p>None.</p>
                            </td>
                          </tr>
                          <tr>
                            <td>FareSourceCode</td>
                            <td>
                              <p>Itinerary Identifier</p>
                            </td>
                            <td>
                              string
                            </td>
                            <td>
                              <p>None.</p>
                            </td>
                          </tr>
                          <tr>
                            <td>NetRate</td>
                            <td>
                              <p>Net Rate</p>
                            </td>
                            <td>
                              decimal number
                            </td>
                            <td>
                              <p>None.</p>
                            </td>
                          </tr>
                          <tr>
                            <td>Currency</td>
                            <td>
                              <p>Currency</p>
                            </td>
                            <td>
                              string
                            </td>
                            <td>
                              <p>None.</p>
                            </td>
                          </tr>
                          <tr>
                            <td>OriginDestinationOptions</td>
                            <td>
                              <p>Origin Destination Options</p>
                            </td>
                            <td>
                              <p>Collection of RailOriginDestinationOption</p>
                            </td>
                            <td>
                              <p>None.</p>
                            </td>
                        </tr>
                        <tr>
                          <td colSpan={4}>
                            <Table bordered>
                              <tbody>
                                  <tr>
                                    <td>JourneyDurationPerMinute</td>
                                    <td>
                                      <p>Journey Duration Per Minute</p>
                                    </td>
                                    <td>
                                      integer
                                    </td>
                                    <td>
                                      <p>None.</p>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>RailSegments</td>
                                    <td>
                                      <p>Rail Segments</p>
                                    </td>
                                    <td>
                                      <p>Collection of RailSegment</p>
                                    </td>
                                    <td>
                                      <p>None.</p>
                                    </td>
                                  </tr>

                                <tr>
                                  <td colSpan={4}>
                                    <Table bordered>
                                      <tbody>
                                        <tr>
                                          <td>ResBookDesigCode</td>
                                          <td>
                                            <p></p>
                                          </td>
                                          <td>
                                            string
                                          </td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>Class</td>
                                          <td>
                                            <p></p>
                                          </td>
                                          <td>
                                            string
                                          </td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>DepartureDateTime</td>
                                          <td>
                                            <p>Departure Date and Time</p>
                                          </td>
                                          <td>
                                            date
                                          </td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>ArrivalDateTime</td>
                                          <td>
                                            <p>Arrival Date and Time</p>
                                          </td>
                                          <td>
                                            date
                                          </td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>StopQuantity</td>
                                          <td>
                                            <p></p>
                                          </td>
                                          <td>
                                            integer
                                          </td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>Code</td>
                                          <td>
                                            <p></p>
                                          </td>
                                          <td>
                                            string
                                          </td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>Duration</td>
                                          <td>
                                            <p></p>
                                          </td>
                                          <td>
                                            string
                                          </td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>DurationPerMinute</td>
                                          <td>
                                            <p></p>
                                          </td>
                                          <td>
                                            integer
                                          </td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>Departure</td>
                                          <td>
                                            <p></p>
                                          </td>
                                          <td>
                                            string
                                          </td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>SupplierDeparture</td>
                                          <td>
                                            <p></p>
                                          </td>
                                          <td>
                                            string
                                          </td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>Arrival</td>
                                          <td>
                                            <p></p>
                                          </td>
                                          <td>
                                            string
                                          </td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>SupplierArrival</td>
                                          <td>
                                            <p></p>
                                          </td>
                                          <td>
                                            string
                                          </td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>VendingOperator</td>
                                          <td>
                                            <p></p>
                                          </td>
                                          <td>
                                            string
                                          </td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>SupplierVendingOperator</td>
                                          <td>
                                            <p></p>
                                          </td>
                                          <td>
                                            string
                                          </td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>Operator</td>
                                          <td>
                                            <p></p>
                                          </td>
                                          <td>
                                            string
                                          </td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>SupplierOperator</td>
                                          <td>
                                            <p></p>
                                          </td>
                                          <td>
                                            string
                                          </td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>IsReturn</td>
                                          <td>
                                            <p></p>
                                          </td>
                                          <td>
                                            boolean
                                          </td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>SupplierRph</td>
                                          <td>
                                            <p></p>
                                          </td>
                                          <td>
                                            string
                                          </td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>Baggage</td>
                                          <td>
                                            <p></p>
                                          </td>
                                          <td>
                                            string
                                          </td>
                                          <td>
                                            <p>None.</p>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </Table>
                                  </td>
                                </tr>
                            </tbody>
                            </Table>
                          </td>
                          </tr>
                        </tbody>
                  </Table>
                </td>
                </tr>
                </tbody>
            </Table>
            </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <span className="code-section-title">
              Response Formats - application/json, text/json
            </span>
          </Col>
          <Col sm={12}>
            <pre className="code-section">
              {JSON.stringify(SearchResponse, null, 2)}
            </pre>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default TrainSearchPage;
